import { render, staticRenderFns } from "./ContentItem.vue?vue&type=template&id=e5daae5e&scoped=true"
import script from "./ContentItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContentItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ContentItem.vue?vue&type=style&index=0&id=e5daae5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5daae5e",
  null
  
)

export default component.exports